export default __webpack_public_path__ + "static/media/img-1.9c3a9dc5.jpg";